import { Globals } from "./Globals";
import { QFramelessConfigPortPanel } from "./QFramelessConfigPortPanel";

export class QFramelessConfigDynamicPortPanel extends QFramelessConfigPortPanel {
  constructor() {
    super();
  }

  CreateNestedDisplayPort() {}

  DoClosePanel() {
    var gWSMgr = Globals._wsMgr;
    if (this.fPortPanel) gWSMgr.RemovePanel(this.fPortPanel);
  }

  ExecuteCommand(aCmd) {
    var wsMgr = this.fWSMgr;
    var listMgr = this.fListMgr;
    var curChartObj = this.fChartInfo;
    var srcElement = aCmd.GetSourceElement();
    var srcPanel = aCmd.GetSourcePanel();
    var handled = true;
    var doUpdatePanel = false;
    var doUpdateProperty = false;
    var syncKey = "";
    var cmdCode = aCmd.GetCmdCode();
    var cmdProcessor = cmdCode.split("-");

    if (cmdProcessor.length > 1 && cmdProcessor != cmdCode) {
      var subCodeIdx = parseInt(cmdProcessor[1]);
      cmdCode = cmdProcessor.shift();
      var subCode = cmdProcessor.shift(); // second item is subcmd
      var subCode2 = cmdProcessor.join("-");
    }

    var portPanel = this.fPortPanel;
    if (portPanel) {
      var origPanX = portPanel.GetPanX();
      var origPanY = portPanel.GetPanY();
      var curZoom = portPanel.GetScaleFactor();
    }
    var deltaX = 0;
    var deltaY = 0;
    const gDPR = Globals._dpr;
    switch (cmdCode) {
      case "scrollUp":
        deltaY += 25 * curZoom * gDPR;
        portPanel.PanPanel(origPanX, origPanY, deltaX, deltaY);
        break;
      case "scrollDown":
        deltaY += -25 * curZoom * gDPR;
        portPanel.PanPanel(origPanX, origPanY, deltaX, deltaY);
        break;
      default:
        return this.fBackgroundPanel.ExecuteCommand(aCmd);
    }
  }
}
